import Swal from "sweetalert2";
export const successAdd = (item: any) => {
  Swal.fire({
    icon: "success",
    title: item,
    showConfirmButton: false,
    timer: 1800,
  });
};
export const successUpdate = (item: any) => {
  Swal.fire({
    icon: "success",
    title: item,
    showConfirmButton: false,
    timer: 1800,
  });
};
export const successDelete = (item: any) => {
  Swal.fire({
    icon: "success",
    title: item,
    showConfirmButton: false,
    timer: 1800,
  });
};
export const errorAdd = (err: any) => {
  Swal.fire({
    icon: "error",
    text: err,
    showConfirmButton: false,
    timer: 1800,
  });
};
export const warningAlert = (item: any) => {
  Swal.fire({
    icon: "warning",
    title: item,
    showConfirmButton: false,
    timer: 1500,
  });
};
